import $ from 'jquery';
import Handlebars from 'handlebars';
import cookies from 'utils/cookies';
import txtTemplateInfoWindow from 'features/dealers/dealer.infowindow.hbs';
import zip from 'lib/util/zip';
import zipFromText from 'lib/zipFromText';
import batws from 'lib/services/batws';
import Paginator from 'lib/paginator';
import xformDealersCommon from 'lib/transforms/dealer.tmpl.common';
import zipTools from 'components/zip-tools';
import googleMaps from 'googlemaps';
import mapStyles from 'lib/mapStyles';
import modernizr from 'modernizr';
import txtCtas from 'tmpl/ctas.hbs';
import ctaXform from 'lib/transforms/tools.dcr.ctas';
import dealerDirections from 'features/ctas/dealer.directions.cta';
import dealerChat from 'features/ctas/dealer.chat.cta';
import dealerSite from 'features/ctas/dealer.site.cta';
import blocks from 'lib/analytics/blocks/index';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import anAddContext from 'lib/analytics/context.add';
import loader from 'lib/util/loader';
import PageCache from 'lib/page-cache';
import txtTemplate from './dealer.search.hbs';
import txtTemplateMobile from './dealer.search.mobile.hbs';
import txtTemplateSearchControls from './dealer.search.controls.hbs';
import txtTemplateResultsList from './dealer.search.results.list.hbs';
import txtTemplateResultsFooter from './dealer.search.results.footer.hbs';
import getParameterByName from 'lib/getParameterByName';
import responsive from 'lib/responsive';
import 'detectizr';
import 'lib/helpers/ifCond';
import 'lib/helpers/if_eq';
import 'lib/validator';
import 'bootstrapTab';
import 'bootstrapTransition';

var __isMobile = !!modernizr.mobile;
var __confirmedZip = cookies.getItem('isConfirmedZip') === 'true';
var __google = null;
var __tmplParent = Handlebars.compile(__isMobile ? txtTemplateMobile : txtTemplate);
var __tmplSearchControls = Handlebars.compile(txtTemplateSearchControls);
var __tmplResultsList = Handlebars.compile(txtTemplateResultsList);
var __tmplResultsFooter = Handlebars.compile(txtTemplateResultsFooter);
var __tmplInfoWindow = Handlebars.compile(txtTemplateInfoWindow);
var __tmplCtas = Handlebars.compile(txtCtas);
var __showMiraiOption = BATSiteConfig.disabledVehicles.indexOf('mirai') === -1;
var __shownDealers = [];

// TODO: Move to prototype for use within dealer panel components as well?
function __dealerQuery(opts) {
  var paginatorOpts = {
    query: {},
    dataField: 'dealerLocator',
    countField: 'dealerCount',
    xform: xformDealersCommon,
    pageSize: 5
  };
  return $.extend(paginatorOpts, opts);
}

var __identityFilter = function () {
  return true;
};

var __pmaFilter = function (dealer) {
  return dealer.isPma;
};

var __nonPmaFilter = function (dealer) {
  return !dealer.isPma;
};

var __miraiOnly = function (dealer) {
  return dealer.isMirai;
};

function __dealerAddressUrl(dealer) {
  return encodeURI(`${dealer.postalAddress} ${dealer.city} ${dealer.state} ${dealer.zipCode}`);
}

var dealers = {
  load: function (el, config) {
    this.$el = $(el);
    this.ctas = ctaXform(config.ctas);
    this.config = config;
    this.config.useDealerNameSearch = false;
    this.config.showMirai = __showMiraiOption;
    this.config.pmaMode = true;
    this.config.miraiMode = false;
    this.config.firstSearchComplete = cookies.getItem('isConfirmedZip') === 'true';
    this.setMode('pma');
    this.init();
  },

  setMode: function (mode) {
    this.mode = mode;
    if (mode === 'pma') {
      this.filter = __pmaFilter;
    } else if (mode === 'mirai') {
      this.filter = __miraiOnly;
    } else if (mode === 'nonPma') {
      this.filter = __nonPmaFilter;
    } else {
      this.filter = __identityFilter;
    }
  },

  init: function () {
    this.drawParent();
    Handlebars.registerPartial('ctasDealer', __tmplCtas({ ctas: this.ctas }));
    anAddContext(this.$el, blocks.sectionBlock('findadealer'));
    // if zip code from URL param exists, use that
    // for the search
    this.config.useDealerNameSearch = false;

    var zipFromUrlParam = getParameterByName('zipcode');
    var dealerNameFromUrlParam = getParameterByName('dealerName');
    var stateFromUrlParam = getParameterByName('state');
    var miraiFromUrlParam = getParameterByName('mirai');
    this.setMode(miraiFromUrlParam ? 'mirai' : 'pma');

    if (zipFromUrlParam) {
      this.beginSearch(zipFromUrlParam);
    } else if (dealerNameFromUrlParam) {
      this.config.useDealerNameSearch = true;
      this.beginSearch(dealerNameFromUrlParam);
    } else if (stateFromUrlParam) {
      var self = this;
      zipFromText(stateFromUrlParam)
        .then(function (res) {
          self.beginSearch(res, stateFromUrlParam);
        })
        .catch(function (err) { console.log('err in zipFromText: ', err); }); // eslint-disable-line no-console
    } else if (__confirmedZip) {
      this.beginSearch(zip.getCookiedDefaultFallback());
    } else {
      anComponentView(this.$el);
    }
    anClicks(this.$el);
  },

  // todo: move map stuff outta here?
  // this got pretty messy pretty quick, my apologies
  addMarkers: function (dealerRecords) {
    var self = this;
    self.shownCoords = self.shownCoords || [];
    var shownCoordsIdx = self.shownCoords.length;
    var google = __google;
    var coordsToAdd = dealerRecords.map(dealer => dealer.coords);
    var latlngbounds = new google.maps.LatLngBounds();
    self.shownCoords.forEach(coord => latlngbounds.extend(new google.maps.LatLng(coord.lat, coord.lon)));
    var label;
    var infoWin = new google.maps.InfoWindow({});
    var $scope = $('#js-search-results-map', self.$el);

    google.maps.event.addListener(self.map, 'click', function () {
      if (infoWin) {
        infoWin.close();
      }
    });

    coordsToAdd.forEach(function (coordObj) {
      latlngbounds.extend(new google.maps.LatLng(coordObj.lat, coordObj.lon));
      self.shownCoords.push(coordObj);
      label = (shownCoordsIdx += 1).toString();
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(coordObj.lat, coordObj.lon),
        icon: {
          url: `/assets/img/maps/marker-${label}.png`,
          size: new google.maps.Size(34, 50),
          scaledSize: new google.maps.Size(34, 50)
        },
        map: self.map,
        labelClass: 'aa-link'
      });

      google.maps.event.addListener(marker, 'click', (function (marker) {
        var dealerIdx = shownCoordsIdx;

        return function () {
          var ctx = self.config;
          ctx.currentDealer = __shownDealers[dealerIdx - 1];
          infoWin.setContent(__tmplInfoWindow(ctx));
          infoWin.open(self.map, marker);
          google.maps.event.addListener(infoWin, 'domready', () => {
            // console.log('CTX for infoWindow: ', ctx.currentDealer);
            self.addDealerCtas($scope, ctx.currentDealer);
            anAddContext($scope, blocks.dealerBlock(ctx.currentDealer.dataLayer));
          });
        };
      })(marker));
    });
    self.map.fitBounds(latlngbounds);
  },

  drawMap: function (dealerData) {
    var self = this;
    googleMaps()
      .then(function (google) {
        __google = google;
        self.map = new google.maps.Map(document.getElementById('js-search-results-map'), {
          zoom: 9,
          mapTypeControl: false,
          mapTypeId: 'styled_map',
          fullscreenControl: false,
          streetViewControl: false,
          zoomControl: true,
        });
        self.map.mapTypes.set('styled_map', new google.maps.StyledMapType(mapStyles.default));
        self.addMarkers(dealerData);
        self.mapListeners();
      });
  },

  mapListeners: function () {
    var self = this;
    var $listCol = $('.js-results-list', self.$el);
    var $mapCol = $('.js-results-map', self.$el);
    var $expandEl = $('.js-dealer-map-expandable', self.$el);
    var isExpanding = true;
    var $open = $expandEl.children('.js-open');
    var $close = $expandEl.children('.js-close');
    $expandEl.on('click', function (e) {
      e.preventDefault();
      isExpanding = $open.is(':visible');
      // Expand
      if (isExpanding) {
        $open.hide();
        $close.show();
        $listCol.fadeOut(function () {
          $mapCol.addClass('col-sm-12');
          $listCol.removeClass('map-collapsed').addClass('col-sm-12').fadeIn(1000);
          $mapCol.insertBefore($listCol);
          // $parentDealersResult.css('display', 'flex');
          // $parentDealersResult.css('flex-direction', 'column-reverse');
        });
      // collapse
      } else {
        $open.show();
        $close.hide();
        $mapCol.fadeOut(function () {
          $listCol.removeClass('col-sm-12').addClass('map-collapsed');
          $mapCol.removeClass('col-sm-12').fadeIn(1000);
          $listCol.insertBefore($mapCol);
          // $parentDealersResult.css('display', 'block');
          // $parentDealersResult.css('flex-direction', 'none');
        });

      }
    });
  },

  // Clear all results and start anew
  submitSearch: function () {
    var self = this;
    var searchVal = $('.js-search-value', self.$el).val();
    var miraiOptionChecked = $('#mirai-dealer-check', self.$el).prop('checked');
    // need to reset shownCoords. TODO: move to func
    self.shownCoords = [];
    __shownDealers = [];
    self.config.userSearchVal = searchVal;
    $('.js-search-results-list', self.$el).empty();

    // PMA zip Search
    if (searchVal && $.isNumeric(searchVal) && zip.isZipFormatValid(searchVal)) {
      self.setMode(miraiOptionChecked ? 'mirai' : 'pma');
      self.beginSearch(searchVal);

    // Text search (via text to zip)
    } else if (searchVal && !self.config.useDealerNameSearch) {
      zipFromText(searchVal)
        .then(function (res) {
          self.setMode(miraiOptionChecked ? 'mirai' : 'all');
          self.beginSearch(res);
        })
        .catch(function (err) { console.log('err in zipFromText: ', err); }); // eslint-disable-line no-console

    // DealerName search
    } else if (searchVal) {
      self.setMode(miraiOptionChecked ? 'mirai' : 'all');
      self.beginSearch(searchVal);
    }
  },

  beginSearch: function (calcZip, inputValue = null) {
    var self = this;
    var query;
    loader.showLoader();
    self.config.firstSearchComplete = true;
    if (!self.config.userSearchVal) {
      self.config.userSearchVal = calcZip;
    }

    if (self.config.useDealerNameSearch) {
      query = __dealerQuery({
        query: {
          dealerName: calcZip,
          mirai: self.mode === 'mirai'
        }
      });
      self.paginator = new Paginator(batws.geo().dealerDetails, query);
    } else {
      query = __dealerQuery({
        query: {
          zipcode: calcZip,
          mirai: self.mode === 'mirai'
        }
      });
      self.paginator = new Paginator(batws.geo().search, query);
    }
    self.paginator.next()
      .then(function (res) {
        self.drawParent();
        self.showResults(res, inputValue);
      });
  },

  drawParent: function () {
    delete this.map;
    this.$el.html(__tmplParent(this.config));
    this.drawSearchControls();
    loader.hideLoader();
  },

  drawSearchControls: function () {
    this.config.miraiMode = this.mode === 'mirai';
    this.config.pmaMode = this.mode === 'pma';
    $('.js-search-controls', this.$el).html(__tmplSearchControls(this.config));
    this.searchListeners();
  },

  searchListeners: function () {
    var self = this;
    $('.js-search-type', self.$el).on('click', function (e) {
      e.preventDefault();
      if (self.config.useDealerNameSearch) {
        self.config.useDealerNameSearch = false;
      } else {
        self.config.useDealerNameSearch = true;
      }
      self.config.userSearchVal = '';
      self.drawSearchControls();
      $('.text-input').focus();
    });

    $('#autolocate', self.$el).on('click', function () {
      zipTools.geoLocationZip.detect(function (res) {
        $('.js-search-value', self.$el).val(res);
      }, zipTools.reLoadDealerSearchWithoutZip);
    });

    $('form.js-fad-form', self.$el).validate({
      invalidHandler: function (event, validator) {
        self.analyticsFormError(validator);
      },
      submitHandler: function () {
        self.submitSearch();
      }
    });

    PageCache.on('ZIP_CODE_CHANGED', function (newZip) {
      self.beginSearch(newZip);
    });
  },

  showResults: function (dealerData, inputValue = null) {
    var self = this;
    var filteredDealers = $.extend({}, dealerData, {
      records: dealerData.records.filter(self.filter)
    });
    self.config.pmaMode = self.mode === 'pma';
    self.config.miraiMode = self.mode === 'mirai';
    var ctx = self.config;
    ctx.dealerResults = filteredDealers; // Match what we do elsewhere w/ this new prop

    if (filteredDealers.records.length) {
      filteredDealers.records.forEach(function (dealer) {
        ctx.currentDealer = dealer;
        __shownDealers.push(dealer);
        ctx.currentDealer.shownIdx = __shownDealers.length;
        $('.js-search-results-list', self.$el).append(__tmplResultsList(ctx));
        // BAT-5911 - the change for BAT-5757 is breaking the dealer results
        // CTAs, so only animate if mobile
        $('.js-search-results-list').focus();
        if (responsive() === 'sm') {
          $('html, body').animate({
            scrollTop: $('#open-area .nav-tabs').offset().top
          }, 500);
        }
      });
    } else if (filteredDealers.records.length <= 0 && self.mode === 'pma') {
      // BAT-5855 - if no results for PMA, next search by proximity
      // for non PMA, same as when View More Results is clicked
      self.setMode('nonPma');
      if (self.paginator.pageData.count > 0) {
        self.showResults(self.paginator.pageData);
        return;
      }
      delete ctx.currentDealer;
      $('.js-search-results-list', self.$el).append(__tmplResultsList(ctx));
    }
    // console.log('FAD Dealer results CTX for HBS: ', ctx); // eslint-disable-line no-console
    // TODO: move to analytics func
    self.analyticsDealerSearch();

    $('.js-search-results-footer', this.$el).html(__tmplResultsFooter(ctx));
    if (self.map) {
      self.addMarkers(ctx.dealerResults.records);
    } else {
      // TODO: only draw map on mobile, if map pane is visible
      self.drawMap(ctx.dealerResults.records);
    }

    // todo: move to config on each dealer...
    ctx.dealerResults.records.forEach(dealer => {
      var $scope = $(`li.js-result-parent[data-dealercode=${dealer.dealerCode}]`, self.$el);
      self.addDealerCtas($scope, dealer);
      anAddContext(
        $scope,
        blocks.dealerBlock(dealer.dataLayer)
      );
    });
    self.resultEvents();

    if (inputValue != null) {
      $('.js-search-value', self.$el).val(inputValue);
    }
  },

  nextPage: function () {
    var self = this;
    if (self.paginator.hasNext()) {
      self.paginator.next()
        .then(function (res) {
          self.showResults(res);
        })
        .catch(function (err) { console.log('err in nextPage: ', err); }); // eslint-disable-line no-console
    }
  },

  resultEvents: function () {
    var self = this;
    $('.js-page-next', self.$el).on('click', function () {
      if (self.mode === 'pma') {
        self.setMode('nonPma');
        self.showResults(self.paginator.pageData);
      } else {
        self.nextPage();
      }
    });
  },

  addDealerCtas: function ($scope, dealer) {
    dealerSite($scope, dealer.siteUrl);
    dealerChat($scope, dealer.dealerCode, dealer.tdaCode);
    dealerDirections($scope, __dealerAddressUrl(dealer));
  },

  getSearchType: function () {
    if (this.config.useDealerNameSearch) {
      return 'dealername';
    }
    if (this.config.userSearchVal && !$.isNumeric(this.config.userSearchVal)) {
      return 'state';
    }
    return 'zip';
  },

  analyticsDealerSearch: function () {
    anAddContext(this.$el, blocks.dealerSearchBlock(
      this.config.userSearchVal,
      this.getSearchType(),
      __shownDealers.length
    ));
    anComponentView(this.$el, __shownDealers.length > 0 && blocks.keyMetrics('km-dealer-search'));
  },

  analyticsFormError: function () {
    anComponentView(this.$el, blocks.dealerSearchBlock('', this.getSearchType()));
  },
};

export default dealers;
